
export default {
    path: '/',
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ '../../views/home/Home.vue')
}